import {
	COLOR_BASE_GREY_40,
	COLOR_BASE_GREY_5,
	COLOR_BASE_GREY_60,
	SHADOW_BACKGROUND_LEVEL_2_LIGHT,
	SPACING_XL_XL,
	SPACING_XL_XS,
	SPACING_XS_XS,
	SPACING_XXS_XS,
} from '@audi/audi-ui-design-tokens';

import {
	SYS_BREAKPOINT_2_XL,
	SYS_BREAKPOINT_LG,
	SYS_BREAKPOINT_MD,
	SYS_BREAKPOINT_SM,
	SYS_BREAKPOINT_XL,
	SYS_PAGE_MARGIN_2_XL,
	SYS_PAGE_MARGIN_LG,
	SYS_PAGE_MARGIN_MD,
	SYS_PAGE_MARGIN_SM,
	SYS_PAGE_MARGIN_XL,
} from '@oneaudi/unified-web-common';

import styled from 'styled-components';
import { breakPoints, customBreakPoint, mobileBreakPoint } from '~/styles/break-points';
import { transitionDuration, transitionTiming, zIndex, zIndexFront, zIndexTop } from '~/styles/tokens';

export const ConfiguratorOptionStyle = styled.div`
	${customBreakPoint(mobileBreakPoint, 'padding-top: 0;')}

	.headline-container {
		padding-top: 28px;
		padding-bottom: 28px;
		padding-left: ${SYS_PAGE_MARGIN_SM};
		padding-right: ${SYS_PAGE_MARGIN_SM};

		@media screen and (min-width: ${SYS_BREAKPOINT_SM}) {
			padding-left: ${SYS_PAGE_MARGIN_SM};
			padding-right: ${SYS_PAGE_MARGIN_SM};
		}

		@media screen and (min-width: ${SYS_BREAKPOINT_MD}) {
			padding-left: ${SYS_PAGE_MARGIN_MD};
			padding-right: ${SYS_PAGE_MARGIN_MD};
		}

		@media screen and (min-width: ${SYS_BREAKPOINT_LG}) {
			padding-left: ${SYS_PAGE_MARGIN_LG};
			padding-right: ${SYS_PAGE_MARGIN_LG};
		}

		@media screen and (min-width: ${SYS_BREAKPOINT_XL}) {
			padding-left: ${SYS_PAGE_MARGIN_XL};
			padding-right: ${SYS_PAGE_MARGIN_XL};
		}

		@media screen and (min-width: ${SYS_BREAKPOINT_2_XL}) {
			padding-left: ${SYS_PAGE_MARGIN_2_XL};
			padding-right: ${SYS_PAGE_MARGIN_2_XL};
		}
	}

	.float-block:not(:last-child) {
		margin-bottom: 16px;
	}

	.float-block .focus-card {
		filter: ${SHADOW_BACKGROUND_LEVEL_2_LIGHT};
	}

	.float-block.option-headline {
		display: none;
		position: sticky;
		top: 0;
		padding-top: 32px;
		padding-left: ${SPACING_XL_XS}px;
		padding-right: ${SPACING_XL_XS}px;
		padding-bottom: ${SPACING_XXS_XS}px;
		background-color: ${COLOR_BASE_GREY_5};
		z-index: ${zIndexTop};
		transition-timing-function: ${transitionTiming};
		transition-duration: ${transitionDuration}ms;
		transition-property: padding-bottom, top;

		${customBreakPoint(mobileBreakPoint, 'display: block')}
	}

	.scroll-anker {
		margin-bottom: ${SPACING_XL_XS}px;
	}

	.float-block.slider {
		padding-left: 0;
		padding-right: 0;
	}

	.float-block.option-header {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		position: sticky;
		background-color: ${COLOR_BASE_GREY_5};
		transition-timing-function: ${transitionTiming};
		transition-duration: ${transitionDuration}ms;
		transition-property: top;
		padding-bottom: ${SPACING_XS_XS}px;
		z-index: ${zIndex};
	}

	.option-header .option-header__step {
		font-size: 10px;
		width: 100%;
		flex-grow: 1;
		flex-shrink: 1;

		${breakPoints({
			'768': `font-size: 12px;`,
		})}
	}

	.option-header .option-header__main {
		font-size: 12px;
		flex-grow: 1;
		flex-shrink: 0;

		${breakPoints({
			'768': `font-size: 16px;`,
		})}
	}

	.option-header__toggle-view {
		cursor: pointer;
		color: ${COLOR_BASE_GREY_40};
		transition-timing-function: ${transitionTiming};
		transition-duration: ${transitionDuration}ms;
		transition-property: color;

		@media (hover: hover) {
			&:hover {
				color: ${COLOR_BASE_GREY_60};
			}
		}
	}

	.is-loading:after {
		content: '';
		position: absolute;
		width: 100%;
		height: 100%;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: ${zIndexFront};
		background-color: rgba(255, 255, 255, 0.65);
	}

	.float-block.skeleton {
		margin-top: ${SPACING_XL_XL}px;
	}

	.cards {
		padding: ${SPACING_XS_XS}px;
		height: 100%;

		.selection-card__control,
		.selection-card__content {
			padding-left: 0;
			padding-right: 0;
		}
	}
`;
